import React from "react";
import { AdminRole } from "../adminAccess";
import {
    RolePickerContainer,
    RolePickerTitle,
    RolePickerSubtitle,
    RoleButton,
    RoleName,
    RoleEntity,
} from "./RolePicker.styles";

interface RolePickerProps {
    roles: AdminRole[];
    title: string;
    subtitle: string;
    onSelect: (role: AdminRole) => void;
}

/**
 * Lets a user who is an admin in more than one place pick which one they are
 * acting as; choosing one scopes the session to that role (via
 * /user/choose/role). It is handed an already-filtered list of admin roles, so
 * a teacher or student role can never appear here — see resolveAdminAccess.
 */
const RolePicker: React.FC<RolePickerProps> = ({
    roles,
    title,
    subtitle,
    onSelect,
}) => {
    return (
        <RolePickerContainer>
            <RolePickerTitle>{title}</RolePickerTitle>
            <RolePickerSubtitle>{subtitle}</RolePickerSubtitle>

            {roles.map((role) => (
                <RoleButton
                    key={role.key}
                    type="button"
                    onClick={() => onSelect(role)}
                >
                    <RoleName>{role.roleName.toLowerCase()}</RoleName>
                    <RoleEntity>{role.entityName}</RoleEntity>
                </RoleButton>
            ))}
        </RolePickerContainer>
    );
};

export default RolePicker;
